import type { FC } from "react";
import icon from "@/assets/icon.svg";

export const AuthHeaderIcon: FC = () => {
	return (
		<img src={icon} className="mx-auto mb-4 h-12 w-12" />
	);
};
